import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Redirect } from 'react-router-dom';
import core, { App, GQL } from '@gin-betting/core';

import { ACTIVE_MARKET_STATUSES } from 'app-constants';
import { State } from 'types';
import { getRouteBySportType } from 'utils';

const {
    entities: {
        selectors: { selectSportBySlug },
        actions: { getMatchBySlug, getTournamentBySlug },
    },
    utils: { getSportTypeBySport, checkOnRoute },
} = core;

interface Input {
    slug: string;
    path: string;
}

const EntityIdRouteResolver: React.FC<Input> = ({ slug, path }) => {
    const dispatch = useDispatch();
    const sport = useSelector((state: State) =>
        selectSportBySlug(state, { slug })
    );

    useEffect(() => {
        if (
            checkOnRoute(App.Routes.MATCH) ||
            checkOnRoute(App.Routes.OUTRIGHT) ||
            checkOnRoute(App.Routes.RESULT_MATCH)
        ) {
            dispatch(
                getMatchBySlug({
                    slug,
                    marketStatuses: getMarketStatus(),
                })
            );
        }

        if (checkOnRoute(App.Routes.TOURNAMENT)) {
            dispatch(
                getTournamentBySlug({
                    slug,
                })
            );
        }
    }, [dispatch, slug]);

    const sportType = getSportTypeBySport(sport);
    const route = getRouteBySportType(sportType);

    if (!sportType) return null;

    return (
        <Switch>
            <Redirect to={`${route}${path}${slug}`} />
        </Switch>
    );
};

function getMarketStatus(): GQL.MarketStatus[] {
    return checkOnRoute(App.Routes.RESULT_MATCH)
        ? [GQL.MarketStatus.RESULTED]
        : ACTIVE_MARKET_STATUSES;
}

export default EntityIdRouteResolver;
